/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationDetailForAzureMca extends models.BillingInformationBase {
    constructor() {
        super();
        this.setDiscriminator("BillingInformationDetailForAzureMca");
    }

    getFixupPrototypeFunction() { return BillingInformationDetailForAzureMca.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationDetailForAzureMca>): BillingInformationDetailForAzureMca {
        let obj = Object.assign(new BillingInformationDetailForAzureMca(), model);
        BillingInformationDetailForAzureMca.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationDetailForAzureMca>): BillingInformationDetailForAzureMca {
        if (!model) return null;
        return BillingInformationDetailForAzureMca.newInstance(<BillingInformationDetailForAzureMca> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationDetailForAzureMca) {
        if (!obj) return;

        models.BillingInformationDetailForAzureMca.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationDetailForAzureMca): boolean {
        if (models.BillingInformationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationDetailForAzureMca.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.billing_periods) {
            for (let val of this.billing_periods) {
                models.BillingInformationForAzureMca.fixupPrototype(val);
            }
        }
    }

    /**
     * Details for the billing period.
     */
    billing_periods: Array<models.BillingInformationForAzureMca>;

}
